import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

export const getLeaves = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/leave_app/leave-application/`,
      getHeaders()
    );

    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};
export const createLeaveApplication = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/leave_app/leave-application/`,
      data,
      getHeaders()
    );

    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const updateLeaveApplication = async (id, leaveData) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/leave_app/leave-application/${id}/`,
      leaveData,

      getHeaders()
    );

    return response.data;
  } catch (error) {
    console.error("Error updating leave application:", error);
    throw error;
  }
};
export const deleteLeaveApplication = async (id) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/leave_app/leave-application/${id}/`,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    console.error("Error updating leave application:", error);
    throw error;
  }
};
// Leave Approval Service (for Super Admin)
export const approveLeave = async (id, data) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/leave_app/leave-approval/${id}/`,
      { status: data },
      getHeaders()
    );

    return response.data;
  } catch (error) {
    console.error("Error approving leave:", error);
    throw error;
  }
};
